module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external {"root":"BrowserFS","commonjs":"browserfs","commonjs2":"browserfs","amd":"browserfs"}
// module id = 13
// module chunks = 0